import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="px-6 md:px-10 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-1/4">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-store-2-line text-background-50 text-sm"></i>
              </div>
              <span className="text-lg font-heading font-semibold text-foreground-900">
                Hipobuy Spread
              </span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              Your trusted resource for organized product research. Discover curated spreadsheets, comparison guides, and shopping insights all in one place.
            </p>
          </div>

          <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-xs font-label font-semibold uppercase tracking-wider text-foreground-400 mb-4">
                Spreadsheets
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    Hipobuy Spreadsheet
                  </Link>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    Kakobuy Spreadsheet
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    CSSBuy Spreadsheet
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    Superbuy Spreadsheet
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-label font-semibold uppercase tracking-wider text-foreground-400 mb-4">
                Categories
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    Shoes
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    T-Shirts
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    Jackets
                  </a>
                </li>
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    View All Categories
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-label font-semibold uppercase tracking-wider text-foreground-400 mb-4">
                Resources
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/hipobuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    Beginner Guide
                  </Link>
                </li>
                <li>
                  <Link to="/hipobuy-spreadsheet-vs-kakobuy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    Hipobuy vs Kakobuy
                  </Link>
                </li>
                <li>
                  <Link to="/hipobuy-spreadsheet-safety" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    Safety Guide
                  </Link>
                </li>
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 Hipobuy Spread. All rights reserved.
          </p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link to="/" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
              Privacy
            </Link>
            <span className="text-foreground-300">|</span>
            <Link to="/" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
              Terms
            </Link>
            <span className="text-foreground-300">|</span>
            <Link to="/" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
              Disclaimer
            </Link>
            <span className="text-foreground-300">|</span>
            <Link to="/" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
              Safety
            </Link>
            <span className="text-foreground-300">|</span>
            <Link to="/" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}